import {ExpertSystemUsageRatePage} from '@features/expert-system-usage-rate'
import {useExpertSystemHierarchy} from '@hconnect/common/hooks'
import {PageTitle} from '@hconnect/uikit'
import {Stack} from '@mui/material'
import {useTranslation} from 'react-i18next'
import {NavigateFunction, useNavigate} from 'react-router'

import {LocationBreadcrumbs} from '../../shared/components'
import {useTranslationPrefix} from '../../shared/hooks'
import {EXPERT_SYSTEM_USAGE_RATE} from '../../shared/routes'

export const ExpertSystemUsageRate = () => {
  const {t} = useTranslation()
  const {performancePrefix} = useTranslationPrefix()
  const navigate: NavigateFunction = useNavigate()
  const {data: data} = useExpertSystemHierarchy()

  return (
    <ExpertSystemUsageRatePage
      inverted
      titleSlot={
        <Stack>
          <LocationBreadcrumbs sx={{ml: 0}} hierarchy={data} />
          <PageTitle onClick={() => navigate(EXPERT_SYSTEM_USAGE_RATE)} ml={0}>
            {t(`${performancePrefix}.expertSystemUsage.label.header`)}
          </PageTitle>
        </Stack>
      }
    />
  )
}
